<template>
  <div id="userManage">
    <el-row>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
      </el-breadcrumb>
      <el-divider></el-divider>
    </el-row>
    <el-row class="buttons">
      <el-col align="left">
        <el-button type="primary" @click="dialogFormVisible = true">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle">
        <el-table-column type="index" width="50" />
        <el-table-column prop="username" label="用户名">
        </el-table-column>
        <el-table-column prop="description" label="项目名称">
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间">
          <template slot-scope="scope">
            {{ moment(scope.row.created_at).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
        <el-table-column prop="user_id" label="操作" width="300px">
          <template slot-scope="scope">
            <el-button type="text" @click="openChangePasswordDialog(scope.row.user_id)">修改密码</el-button>
            <el-popconfirm style="margin-left: 10px;"
              :title="'确定删除：' + scope.row.description + '(' + scope.row.username + ') 吗？'"
              @confirm="deleteUser(scope.row.user_id)">
              <el-button slot="reference" type="text">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageIndex" :page-sizes="[5, 10, 20]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </el-row>
    <el-dialog title="新增用户" :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="form">
        <el-form-item label="用户名" prop="username" :rules="[{ required: true, message: '用户名不能为空' }]">
          <el-input v-model="form.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="项目名" prop="description" :rules="[{ required: true, message: '项目名称不能为空' }]">
          <el-input v-model="form.description" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" :rules="[{ required: true, message: '密码不能为空' }]">
          <el-input type="password" v-model="form.password" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="createUser">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="changePasswordFormVisible">
      <el-form :model="changePasswordForm" ref="changePasswordForm">
        <el-form-item label="新密码" prop="new_password" :rules="[{ required: true, message: '密码不能为空' }]">
          <el-input type="password" v-model="changePasswordForm.new_password" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changePasswordFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import api from '@/api/api'
import * as moment from 'moment';

export default {
  name: 'userManage',
  components: {
  },
  data() {
    return {
      dialogFormVisible: false,
      changePasswordFormVisible: false,
      form: {
        password: '',
        username: ''
      },
      changePasswordForm: {
        user_id: null,
        new_password: ''
      },
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      headerCellStyle: {
        background: 'rgb(245,245,245)'
      },
      tableData: []
    }
  }, mounted() {
    this.refresh();
    this.moment = moment;
  },
  methods: {
    refresh() {
      const that = this;
      api.post('/users', { pageSize: that.pageSize, pageIndex: that.pageIndex }).then(response => {
        that.tableData = response.data.data;
        console.log(that.tableData)
        that.totalCount = response.data.totalCount;
        console.log(that.tableData)
      })
    },
    handleSizeChange(val) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.refresh();
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.refresh();
    },
    changePassword(userId) {
      const that = this;
      this.$refs['changePasswordForm'].validate(valid => {
        if (valid) {
          api.post('/changePassword', that.changePasswordForm).then(response => {
            if(response.data.success) {
              this.$message({
                message: '重置成功',
                type: 'success'
              })
              this.changePasswordForm.new_password = '';
              that.changePasswordFormVisible = false;
            } else {
              this.$message({
                message: '重置失败',
                type: 'error'
              })
            }
          })
        } else {
          return false;
        }
      })
    },
    openChangePasswordDialog(user_id) {
      this.changePasswordForm.user_id = user_id;
      this.changePasswordForm.new_password = '';
      this.changePasswordFormVisible = true;
    },
    createUser() {
      const that = this;
      this.$refs['form'].validate((valid) => {
        if (valid) {
          api.post('/createUser', that.form).then(response => {
            const data = response.data;
            if (data.success) {
              that.$message({
                message: '创建成功',
                type: 'success'
              });
              that.$refs['form'].resetFields();
              that.dialogFormVisible = false;
            } else {
              that.$message({
                message: '创建失败',
                type: 'error'
              });
            }
            that.refresh();
          })
        } else {
          return false;
        }
      })
    },
    deleteUser(userId) {
      const that = this;
      api.post('/deleteUser', {
        user_id: userId
      }).then(response => {
          that.$message({
            message: '删除成功',
            type: 'success'
          });
        that.refresh();
      }).catch(error => {
        that.$message({
            message: '删除失败，存在与用户相关的数据',
            type: 'error'
          });
      })
    }
  }
}
</script>

<style lang="less" scoped>
#userManage {
  padding: 20px;
}

.buttons {
  margin-bottom: 20px;
}

.pagination {
  margin-top: 20px;
}
</style>
